/* Nikos — mouse drag-to-scroll for the mobile carousels.
   Touch already works natively (overflow-x:auto); this adds click-and-drag for
   mouse/trackpad. Leaves touch to the browser, and suppresses the click that would
   otherwise fire on a card link at the end of a drag. */
(function () {
  var SELECTORS = [
    '.nkc-grid',
    '[id*="__section_az4FcC"] .custom-section-content > .layout-panel-flex'
  ];

  function enable(el) {
    if (el.dataset.dragScroll) return;
    el.dataset.dragScroll = '1';

    var down = false, startX = 0, startScroll = 0, moved = false;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;        // native touch handles swipe
      if (el.scrollWidth <= el.clientWidth) return; // not a carousel here (desktop grid)
      down = true; moved = false;
      startX = e.clientX; startScroll = el.scrollLeft;
      el.classList.add('nkc-dragging');
      el.setPointerCapture && el.setPointerCapture(e.pointerId);
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (!down) return;
      down = false;
      el.classList.remove('nkc-dragging');
      if (moved) {
        // swallow the click that follows a drag so it doesn't open a card
        var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        el.addEventListener('click', swallow, true);
        setTimeout(function () { el.removeEventListener('click', swallow, true); }, 60);
      }
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', endDrag);
  }

  function init() {
    document.querySelectorAll(SELECTORS.join(',')).forEach(enable);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
